import { CUSTOM_DROPDOWN_EVENT, SELECTED_VALUE_CLASSNAME } from '@app/dropdown';

const TOC_SELECTOR_CLASSNAME = '.toc-main';
const TOC_MOBILE_SELECTOR_CLASSNAME = '.toc-mobile';
const DOMAIN_SELECTOR_CLASSNAME = '.domain-selector';
const DOMAIN_CLASSNAME = '.domain-value';
const DOMAIN_KEY = 'domainValue';
const QUERY_DOMAIN_KEY = 'domain';

const DEFAULT_DOMAIN = { domainName: 'EU2', domainValue: 'eu2.coralogix.com' };
const DOMAIN_LIST = [
  { domainName: 'US1', domainValue: 'us1.coralogix.com' },
  { domainName: 'US2', domainValue: 'us2.coralogix.com' },
  { domainName: 'EU1', domainValue: 'eu1.coralogix.com' },
  { domainName: 'EU2', domainValue: 'eu2.coralogix.com' },
  { domainName: 'AP1', domainValue: 'ap1.coralogix.com' },
  { domainName: 'AP2', domainValue: 'ap2.coralogix.com' },
  { domainName: 'AP3', domainValue: 'ap3.coralogix.com' },
];

const setDomainValues = (
  elements: NodeListOf<HTMLSpanElement>,
  domain: string
) => {
  elements.forEach((element) => {
    element.innerText = domain;
  });
};

export const initDomainSelector = () => {
  const { referrer } = document;

  let domainReferrer = null;

  const url = new URL(window.location.href);
  const domainQueryParam = url.searchParams.get(QUERY_DOMAIN_KEY);
  const findBy = domainQueryParam || referrer;

  if (findBy) {
    domainReferrer = DOMAIN_LIST.find(
      ({ domainName, domainValue }) =>
        findBy.includes(domainValue) || findBy.includes(domainName)
    );

    if (domainReferrer) {
      localStorage.setItem(DOMAIN_KEY, JSON.stringify(domainReferrer));
    }
  }

  const contentEl = document.querySelector('.md-content') as HTMLDivElement;

  const domainValueTag = '<span class="domain-value"></span>';

  contentEl.innerHTML = contentEl.innerHTML
    .replaceAll(
      '&lt;span class="domain-value"&gt;&lt;/span&gt;',
      domainValueTag
    )
    .replaceAll(
      /&lt;span.*domain.*-.*value.*&gt;&lt;\/span&gt;/gi,
      domainValueTag
    );

  const { domainName, domainValue } =
    domainReferrer ||
    JSON.parse(localStorage.getItem(DOMAIN_KEY) || '""') ||
    DEFAULT_DOMAIN;

  let parentSelector = '';
  const domainDropdownTocEl = document.querySelector(
    TOC_SELECTOR_CLASSNAME
  ) as HTMLSpanElement;

  if (!domainDropdownTocEl) {
    return;
  }

  const domainDropdownTocNavEl = domainDropdownTocEl.closest(
    '.md-sidebar[data-md-type="toc"]'
  ) as HTMLDivElement;

  const domainDropdownTocParentStyle = getComputedStyle(domainDropdownTocNavEl);

  parentSelector =
    domainDropdownTocParentStyle.display === 'none'
      ? TOC_MOBILE_SELECTOR_CLASSNAME
      : TOC_SELECTOR_CLASSNAME;

  const dropdownValueEl = document.querySelector(
    `${parentSelector} ${DOMAIN_SELECTOR_CLASSNAME} ${SELECTED_VALUE_CLASSNAME}`
  ) as HTMLSpanElement;

  if (domainName && dropdownValueEl) {
    dropdownValueEl.textContent = domainName;
  }

  const domainValueElements = document.querySelectorAll(
    DOMAIN_CLASSNAME
  ) as NodeListOf<HTMLSpanElement>;

  setDomainValues(domainValueElements, domainValue);

  if (dropdownValueEl) {
    dropdownValueEl.addEventListener(CUSTOM_DROPDOWN_EVENT, (({
      detail: { domainName, domainValue },
    }: CustomEvent) => {
      localStorage.setItem(
        DOMAIN_KEY,
        JSON.stringify({ domainName, domainValue })
      );

      const currentUrl = new URL(window.location.href);

      currentUrl.searchParams.set(QUERY_DOMAIN_KEY, domainName);
      window.history.pushState({}, '', currentUrl);

      setDomainValues(domainValueElements, domainValue);
    }) as EventListener);
  }
};
